import { matches } from '@js/modules/utilities';
import * as classes from '@js/constants/classes';
import * as events from '@js/constants/events';
/**
 * Table.
 *
 * Adds table functionality.
 */
class Table {
    constructor(element) {
        this.element = element;
        this.triggerSelector = '[data-table-trigger]';
        this.targetSelector = '[data-table-target]';
        this.handleClick = this.handleClick.bind(this);
        this.element.addEventListener(events.CLICK, this.handleClick);
    }
    /**
     * Handles click events.
     */
    handleClick(event) {
        const target = event.target;
        const trigger = matches(target, this.triggerSelector);
        if (!trigger)
            return;
        const targetTableSelector = trigger.getAttribute('data-table-trigger');
        const currentTable = this.element.querySelector(`[data-table-target="${targetTableSelector}"]`);
        if (!currentTable)
            return;
        const triggerElements = this.element.querySelectorAll(this.triggerSelector);
        const tableElements = this.element.querySelectorAll(this.targetSelector);
        triggerElements.forEach(element => {
            element.classList.remove(classes.FONT_EMPHASIS);
            element.classList.remove(classes.TEXT_PRIMARY);
            element.classList.remove('border-blue-500');
        });
        tableElements.forEach(element => {
            element.classList.add(classes.HIDDEN);
        });
        trigger.classList.add(classes.FONT_EMPHASIS);
        currentTable.classList.remove(classes.HIDDEN);
        trigger.classList.add(classes.TEXT_PRIMARY);
        trigger.classList.add('border-blue-500');
    }
}
export default Table;
